/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserBlocker, UserKeyword } from '@/api/types/user';

export interface StoreUserBlockState {
  blockers: UserBlocker[];
  keywords: UserKeyword[];
  maxLimit: number;
  anonyCount: number;
}

export default {
  namespaced: true,
  state: {
    blockers: [],
    keywords: [],
    maxLimit: 0,
    anonyCount: 0,
  },
  getters: {},
  actions: {
    [USER.GET_BLOCKER](_, { id }) {
      return new Promise((resolve, reject) => {
        api.getBlocker(id).then((res) => {
          resolve(res.data);
        }).catch(reject);
      });
    },
    [USER.GET_BLOCKERS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getBlockers().then((res) => {
          commit(USER.GET_BLOCKERS, res);
          resolve();
        }).catch(reject);
      });
    },
    [USER.SET_BLOCKER]({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        api.setBlocker(params.id, params.body).then(() => {
          dispatch(USER.GET_BLOCKERS);
          resolve();
        }).catch(reject);
      });
    },
    [USER.DEL_BLOCKER]({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.deleteBlocker(params.id).then(() => {
          commit(USER.DEL_BLOCKER, params.id);
          resolve();
        }).catch(reject);
      });
    },
    [USER.GET_KEYWORDS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getKeyWords().then((res) => {
          commit(USER.GET_KEYWORDS, res.data);
          resolve();
        }).catch(reject);
      });
    },
    [USER.DEL_KEYWORD]({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.deleteKeyWord(params.word).then(() => {
          commit(USER.DEL_KEYWORD, params.word);
          resolve();
        }).catch(reject);
      });
    },
    [USER.ADD_KEYWORD]({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        api.setKeyWord(params.word).then(() => {
          dispatch(USER.GET_KEYWORDS);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_BLOCKERS](state, data) {
      state.blockers = data.data;
      state.maxLimit = data.extra.maxLimit;
      state.anonyCount = data.extra.anonyCount || 0;
    },
    [USER.DEL_BLOCKER](state, id) {
      const index = state.blockers.findIndex(e => e.otherId === id);
      state.blockers.splice(index, 1);
    },
    [USER.GET_KEYWORDS](state, data) {
      state.keywords = data;
    },
    [USER.DEL_KEYWORD](state, word) {
      const index = state.keywords.findIndex(e => e.word === word);
      state.keywords.splice(index, 1);
    },
  },
};
